import { default as MuiTable, TableProps } from '@mui/material/Table'
import * as React from 'react'

export const Table = React.forwardRef<HTMLTableElement, TableProps>((props, ref) => {
  return <MuiTable ref={ref} {...props} />
})

export default Table
